module.exports = __webpack_public_path__ + "static/media/pause.cd7da876.svg";